// extracted by mini-css-extract-plugin
export default {"list":"List-module--list--aWbfK","element":"List-module--element--BZrm-","meta":"List-module--meta--K0S-y"};